import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Form, FormGroup, SubmitButton } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

export class PaymentDetailsView extends Component {
  constructor(props){
    super(props);
    this.toggleEdit = this.toggleEdit.bind(this);
  }
  toggleEdit(e){
    e.preventDefault();
    this.props.toggleEdit();
  }
  render() {
    const {
      payment,
      editing,
      formState,
      channelTypes,
      channelStatus,
      submitForm,
      onFormUpdate,
      removeItem,
      addChannel,
      toggle,
      expanded,
      isEven,
      amazonAccounts,
    } = this.props;
    const trade = payment.trade || {};
    let tradeDate = trade.date || payment.date;
    tradeDate = tradeDate && new Date(tradeDate).toLocaleDateString();
    const amazonAccountsMap = {};
    amazonAccounts.forEach(account => amazonAccountsMap[account.value] = account.label);

    return (
      <Form element="tbody" state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
        {editing ? (
          <tr className={isEven ? 'even' : 'odd'}>
            <td><Link to={`/workArea/trades/completed?tradeId=${payment.tradeId}`}>{payment.tradeId}</Link></td>
            <td>{trade.trade_status}</td>
            <td>{tradeDate}</td>
            <td>
              <FormGroup>
                <Input type="text" name="code" />
              </FormGroup>
            </td>
            <td>
              <FormGroup>
                <Input type="text" name="pin" />
              </FormGroup>
            </td>
            <td>
              <FormGroup>
                <Select name="status" options={enums.paymentStatus}/>
              </FormGroup>
            </td>
            <td>{payment.type}</td>
            <td>{trade.fiat_currency_code}</td>
            <td>
              <FormGroup>
                <Input type="number" name="value" />
              </FormGroup>
            </td>
            <td>{payment.remainingValue}</td>
            <td>
              <div className="action-buttons">
                <button onClick={toggle}><i className="fi-arrows-out size-18"></i> view more</button>
              </div>
            </td>
          </tr>
        ) : (
          <tr className={isEven ? 'even' : 'odd'}>
            <td><Link to={`/workArea/trades/completed?tradeId=${payment.tradeId}`}>{payment.tradeId}</Link></td>
            <td>{trade.trade_status}</td>
            <td>{tradeDate}</td>
            <td>{payment.code}</td>
            <td>{payment.pin}</td>
            <td>{(enums.paymentStatusMap[payment.status] || {}).label}</td>
            <td>{payment.type}</td>
            <td>{trade.fiat_currency_code}</td>
            <td>{payment.value}</td>
            <td>{payment.remainingValue}</td>
            <td>{amazonAccountsMap[payment.account]}</td>
            <td>{payment.orderNumber}</td>
            <td>
              <div className="action-buttons">
                <button onClick={toggle}><i className="fi-arrows-out size-18"></i> view more</button>
              </div>
            </td>
          </tr>
        )}

        {expanded && (
          <tr className="expanded-trade">
            <td colSpan="13">
              <div className="payment-details">

                <div className="channel-details">
                  <div className="sales-channels">
                    <div className="title">Sales Channels</div>
                    <table>
                      <thead>
                      <tr>
                        <th>created</th>
                        <th>completed</th>
                        <th>type</th>
                        <th>value</th>
                        <th>status</th>
                        <th>order #</th>
                        <th>Account</th>
                        <th>Email</th>
                        {editing && (<th></th>)}
                      </tr>
                      </thead>

                      {editing ? (
                        <tbody>
                        {formState.data.channels.map((channel, i) => (
                          <tr key={i}>
                            <td>
                              <FormGroup>
                                <Input name={`channels[${i}].created`} type="date" placeholder="YYYY-MM-DD"/>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Input name={`channels[${i}].completed`} type="date" placeholder="YYYY-MM-DD"/>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Select name={`channels[${i}].type`} options={channelTypes}/>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Input name={`channels[${i}].value`} type="number"
                                       disabled={['Paxful', 'Gameflip', 'G2A', 'Raise.com', 'Cardpool'].indexOf(formState.data.channels[i].type) > -1}/>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Select name={`channels[${i}].status`} options={channelStatus}/>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Input name={`channels[${i}].orderNumber`} type="text"/>
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Select name={`channels[${i}].account`} options={amazonAccounts} emptyOption />
                              </FormGroup>
                            </td>
                            <td>
                              <FormGroup>
                                <Input name={`channels[${i}].email`} type="text"/>
                              </FormGroup>
                            </td>
                            <td>
                              <button type="button" onClick={() => removeItem('channels', i)}>x</button>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      ) : (
                        <tbody>
                        {payment.channels.map((channel, i) => (
                          <tr key={i}>
                            <td>{channel.created}</td>
                            <td>{channel.completed}</td>
                            <td>{channel.type}</td>
                            <td>{channel.value}</td>
                            <td>{(enums.salesChannelStatusMap[channel.status] || {}).label}</td>
                            <td>{channel.orderNumber}</td>
                            <td>{channel.account}</td>
                            <td>{channel.email}</td>
                          </tr>
                        ))}
                        </tbody>
                      )}

                    </table>

                    {editing && (
                      <div className="actions">
                        <button className="button" type="button" onClick={addChannel}>+</button>
                      </div>
                    )}
                  </div>
                  <div className="payment-actions">
                    {editing ? (
                      <div>
                        <button className="button" type="button" onClick={this.toggleEdit}>Cancel</button>
                        <SubmitButton className="button">Save</SubmitButton>
                      </div>
                    ) : (
                      <div>
                        <button className="button" type="button" onClick={this.toggleEdit}>Edit</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        )}

      </Form>

    );
  }

}

export default PaymentDetailsView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentDetails/PaymentDetails.view.js